import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  row: {
    cursor: 'pointer',
    '&:focus-visible': {
      outline: 'none',
      boxShadow: 'inset 0 0 0 2px var(--brand-teal-soft)'
    }
  },
  badgeCell: {
    '.ant-badge': {
      overflow: 'visible',
      paddingInlineStart: token.paddingXXS
    }
  },
  title: {
    color: token.colorText,
    '&:hover': {
      color: token.colorPrimaryHover
    }
  },
  titleUpdated: {
    color: token.colorPrimary,
    fontWeight: token.fontWeightStrong
  }
}))
